import { serviceLocator } from '@/utils/providers/serviceLocator'
import { useQuery } from '@/utils/asyncStateManagement/useQuery'
import type { ChatRepository } from '../repositories/ChatRepository'

export async function updateReadMessageCase(userId: string) {
  const newRepository = serviceLocator.getService<ChatRepository>('ChatService')

  const { data } = await useQuery({
    fetcher: async () => await newRepository?.updateReadMessage(userId),
    key: 'chat',
    filterData: JSON.stringify(userId),
    skipCaching: true
  })

  if (data.value?.error) return
  return data.value
}
